import { environmentCommon } from './../environments/environment';
import { AppInitializationService } from './../app/shared/services/app-initialization.service';
import { AuthService } from './../app/shared/services/auth.service';
import { AppService } from './../app/shared/state/app/app.service';
import { environmentNew } from './../../src/environments/environment';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CookieModule, CookieService } from 'ngx-cookie';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { CoreModule } from '../app/core/core.module';
import { SharedComponentsModule } from '../app/shared/components/shared-components.module';
import { LoginModalModule } from '../app/shared/login-modal/login-modal.module';
import { GloLoginModalModule } from '../app/shared/glo-login-modal/login-modal.module';
import { QuestionnairePostCheckoutModule } from '../app/pl-features/glo-design/questionnaire-post-checkout/questionnaire-post-checkout.module';
import { BackButtonService } from '../app/shared/services/back-button.service';
import { ConstantsService } from '../app/shared/services/constants.service';
import { EnvironmentService } from '../app/shared/services/environment.service';
import { EventService } from '../app/shared/services/event.service';
import { ExperimentsService } from '../app/shared/services/experiments/experiments.service';
import { CanActivatePostCoQxGuard } from '../app/shared/services/guards/can-activate-post-co-qx.guard';
import { CanActivateQuestionaireGuard } from '../app/shared/services/guards/can-activate-questionaire.guard';
import { CheckoutBackButtonGuard } from '../app/shared/services/guards/checkout-back-button.guard';
import { AuthInterceptorService } from '../app/shared/services/HttpInterceptors/auth-interceptor.service';
import { ProductDefinitionService } from '../app/shared/services/product-definition/product-definition.service';
import { QuestionnaireRoutingService } from '../app/shared/services/questionnaire-routing/questionnaire-routing.service';
import { QuestionnaireMappingService } from '../app/shared/services/questionnaire/questionnaire-mapping.service';
import { QuestionnaireService } from '../app/shared/services/questionnaire/questionnaire.service';
import { SEADService } from '../app/shared/services/tracking/sead.service';
import { TealiumTagService, TealiumUtagService } from '../app/shared/services/tracking/tealium-tag.service';
import { TrackSEMDataService } from '../app/shared/services/tracking/track-sem-data.service';
import { TrackingService } from '../app/shared/services/tracking/tracking.service';
import { WindowRef } from '../app/shared/services/windowRef.service';
import { AppDesktopRoutingModule } from './app-desktop-routing.module';
import { AppDesktopComponent } from './app-desktop.component';
import { MomentDateFormatter } from '../app/shared/services/formatters/ngb-datepicker-formatter';
import { QuestionnaireRoutingMobileNativeService } from '../app/shared/services/questionnaire-routing-mobile-native/questionnaire-routing-mobile-native.service';
import {
  QueueModule,
  TrackJsErrorLogModule,
  UtilitiesModule
} from '@legalzoom/business-formation-sdk';
import { OrderModule } from '@legalzoom/order-sdk';
import { WebSessionModule } from '@legalzoom/web-session-sdk';
import { CrossSellService } from './../app/shared/services/cross-sell.service';
import { CookieService as ngxCookieService } from 'ngx-cookie-service';
import { TaggingModule } from '@legalzoom/tagging-sdk';
import { ProcessingOrderModule } from '@legalzoom/processing-order-sdk';
import { AddressAutocompleteModule } from '@legalzoom/address-autocomplete-sdk';
import { CartModule } from '@legalzoom/cart-sdk';
import { CustomerModule } from '@legalzoom/customer-sdk';
import { QuestionnaireStorageModule } from '@legalzoom/questionnaire-storage-sdk';
import { BusinessNameCheckModule } from '@legalzoom/business-name-check-sdk';
import { TrackingModule } from '@legalzoom/tracking-sdk';
import { GcCheckoutModule } from '@legalzoom/lib-checkout';
import { environment, environmentGC } from '../../src/environments/environment';

import { QuestionnaireAnswerModule } from '@legalzoom/questionnaire-answer-sdk';
import { PaymentModule } from '@legalzoom/payment-sdk';
import { ProductModule } from '@legalzoom/product-sdk';
import { ThemeService } from './../app/shared/services/theme.service';
import { GloComponentsModule } from './../app/pl-features/glo-design/shared/components/glo-components.module';
import { NoCacheInterceptor } from '../app/shared/services/HttpInterceptors/no-cache.interceptor';

@NgModule({
  declarations: [
    AppDesktopComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedComponentsModule,
    AppDesktopRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CookieModule.forRoot(),
    DeviceDetectorModule.forRoot(),
    TrackJsErrorLogModule.forRoot(),
    CoreModule,
    HttpClientModule,
    NgxPageScrollModule,
    LoginModalModule,
    GloLoginModalModule,
    GloComponentsModule,
    QuestionnairePostCheckoutModule,
    OrderModule.forRoot(environmentCommon),
    ProcessingOrderModule.forRoot(environmentCommon),
    QuestionnaireAnswerModule.forRoot(environmentCommon),
    QuestionnaireStorageModule.forRoot(environmentCommon),
    QueueModule,
    TrackJsErrorLogModule,
    WebSessionModule.forRoot(environmentCommon),
    UtilitiesModule.forRoot(environmentNew),
    AddressAutocompleteModule.forRoot(environmentCommon),
    BusinessNameCheckModule.forRoot(environmentCommon),
    TaggingModule.forRoot(environmentCommon),
    CartModule.forRoot(environmentCommon),
    CustomerModule.forRoot(environmentCommon),
    TrackingModule.forRoot(environmentCommon),
    GcCheckoutModule.forRoot(environmentGC),
    PaymentModule.forRoot(environmentCommon),
    ProductModule.forRoot(environmentCommon)
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: NgbDateParserFormatter,
      useClass: MomentDateFormatter
    },
    Title,
    EnvironmentService,
    WindowRef,
    TrackingService,
    TrackSEMDataService,
    TealiumTagService,
    TealiumUtagService,
    SEADService,
    QuestionnaireService,
    AppService,
    AuthService,
    CookieService,
    ngxCookieService,
    AppInitializationService,
    QuestionnaireRoutingService,
    QuestionnaireRoutingMobileNativeService,
    CanActivateQuestionaireGuard,
    ConstantsService,
    CanActivatePostCoQxGuard,
    ExperimentsService,
    BackButtonService,
    CheckoutBackButtonGuard,
    ProductDefinitionService,
    QuestionnaireMappingService,
    EventService,
    CrossSellService,
    ThemeService
  ],
  bootstrap: [AppDesktopComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})

export class AppDesktopModule {

  constructor(private themeService: ThemeService) {
  }
}
